import { ReactNode } from "react";
import { ProgressSpinner } from "primereact/progressspinner";

import { PageHeader } from "../../../components/ui";
import { CATALOG_CONTENT_STYLE } from "../../../components/ui/CatalogCard";

// §5.1 — la card de las pantallas de Chispas lleva el padding normativo (32px 40px 40px), no el
// p-3 de PrimeFlex; mismo radio que las cards de Asistencias, Banners y Reportes. `relative` es
// para que el overlay de carga fría del Dashboard quede dentro de la card.
const POINTS_PAGE_CARD_STYLE = {
  ...CATALOG_CONTENT_STYLE,
  borderRadius: "var(--radius-lg)",
  position: "relative" as const,
};

interface PointsPageCardProps {
  children: ReactNode;
  /** Ej. "type-scale": la escala tipográfica §3.3 de layout.css. */
  className?: string;
}

export const PointsPageCard = ({ children, className = "" }: PointsPageCardProps) => (
  <div className={`p-card ${className}`} style={POINTS_PAGE_CARD_STYLE}>
    {children}
  </div>
);

/** Carga fría de una pantalla de Chispas: título + spinner, dentro de la misma card. */
export const PointsPageLoading = ({ title, className }: { title: string; className?: string }) => (
  <PointsPageCard className={className}>
    <PageHeader title={title} />
    <div className="flex justify-content-center align-items-center" style={{ height: "200px" }}>
      <ProgressSpinner />
    </div>
  </PointsPageCard>
);
